module.exports = __webpack_public_path__ + "img/prd_xsys.485448e6.png";